export { commonPropKeys as propKeys } from '../types.esm.js';

var logomarkSizes = {
  xs: 16,
  sm: 32,
  md: 48,
  lg: 64,
  xl: 96,
  '2xl': 128,
  '3xl': 256
};

export { logomarkSizes };
//# sourceMappingURL=types.esm.js.map
